"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirestoreKeys = void 0;
/** Key-Factory
 * La idea es que tengamos keys específicas para las distintas áreas para que sean fáciles de cancelar, de entender y de usar, para ello
 * tenemos al menos 4 niveles de profundidad, todas las keys empiezan con: 'Firestore-Query' le siguen con el área de la que son, como puede ser 'Corporate' o 'Especialista'
 * El tercer nivel de profundidad es el nombre de la función o llamada, tiene que ser claro sobre que hace, el cuarto son todas las dependencias de la llamada en cuestión, ahí podes crear una mini key-factory si lo necesitas.
 * Podes aprender más de esto acá: https://tkdodo.eu/blog/effective-react-query-keys
 */
exports.FirestoreKeys = {
    all: ["Firestore-Query"],
    Corporate: (identifier, elements) => [
        {
            ...identifier,
            category: "Corporate"
        },
        ...elements
    ],
    CorporateUser: (identifier, elements) => [
        {
            ...identifier,
            category: "CorporateUser"
        },
        ...elements
    ],
    Especialista: (identifier, elements) => [
        {
            ...identifier,
            category: "Especialista"
        },
        ...elements
    ],
    Guardia: (identifier, elements) => [
        {
            ...identifier,
            category: "Guardia"
        },
        ...elements
    ],
    MedicalRecords: (identifier, elements) => [
        {
            ...identifier,
            category: "MedicalRecords"
        },
        ...elements
    ],
    Params: (identifier, elements) => [
        {
            ...identifier,
            category: "Params"
        },
        ...elements
    ],
    Suscription: (identifier, elements) => [
        {
            ...identifier,
            category: "Suscription"
        },
        ...elements
    ],
    User: (identifier, elements) => [
        {
            ...identifier,
            category: "User"
        },
        ...elements
    ],
    Prescriptions: (identifier, elements) => [
        {
            ...identifier,
            category: "Prescriptions"
        },
        ...elements
    ],
    Pillbox: (identifier, elements) => [
        {
            ...identifier,
            category: "Pillbox"
        },
        ...elements
    ],
    Appointments: (identifier, elements) => [
        {
            ...identifier,
            category: "Appointments"
        },
        ...elements
    ],
    Events: (identifier, elements) => [
        {
            ...identifier,
            category: "Events"
        },
        ...elements
    ],
    WithoutCategory: (identifier, elements) => [
        {
            ...identifier,
            category: "WithoutCategory"
        },
        ...elements
    ],
    Providers: (identifier, elements) => [
        {
            ...identifier,
            category: "Providers"
        },
        ...elements
    ],
};
